import * as soberTheme from '../dist/main'

if (!globalThis.sober) globalThis.sober = {}
globalThis.sober = { ...globalThis.sober, theme: soberTheme }